import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogCustomModule } from '../mat-dialog-custom/mat-dialog-custom.module';
import { DeleteProviderComponent } from './delete-provider.component';
import { MatStepperCustomModule } from '@shared/mat-stepper-custom/mat-stepper-custom.module';

@NgModule({
  declarations: [DeleteProviderComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    TranslateModule,
    MatDialogCustomModule,
    MatStepperCustomModule,
  ],
  exports: [DeleteProviderComponent],
})
export class DeleteProviderModule {}
